import { ActionCreator } from "redux";
import {
    CategorizedAppointmentDataDto
} from "../../dtos/KioskDtos.dtos";
import {
    STAGE_APPOINTMENTS,
    SHOW_CONFIRMATION_SECTION,
    CONFIRM_APPOINTMENT
} from "./constants";
import {
    StageAppointmentsAction,
    ShowConfirmationSectionAction,
    ConfirmAppointmentAction
} from "./type";

/**
 * @name confirmAppointment
 * @constructs ConfirmAppointmentAction
 * @param {boolean} confirmed
 */
export const confirmAppointment: ActionCreator<ConfirmAppointmentAction> = (confirmed: boolean) => ({
    type: CONFIRM_APPOINTMENT,
    payload: {
        confirmed
    }
});

/**
 * @name showConfirmationModal
 * @constructs ShowConfirmationModalAction
 * @param {boolean} show
 */
export const showConfirmationSection: ActionCreator<ShowConfirmationSectionAction> = (show: boolean) => ({
    type: SHOW_CONFIRMATION_SECTION,
    payload: {
        show
    }
});

/**
 * @name stageAppointments
 * @constructs StageAppointmentsAction
 * @param {AppointmentData[]} appointments
 */
export const stageAppointments: ActionCreator<StageAppointmentsAction> = (appointments: CategorizedAppointmentDataDto) => ({
    type: STAGE_APPOINTMENTS,
    payload: {
        appointments
    }
});



// WEBPACK FOOTER //
// ./src/store/Appointment/actions.ts